import { useMemo } from 'react';
import { PPTOpportunityData } from '../types';
import { useOpportunityProjectIds } from '@/features/projects';
import { useNormalizedProjectsByIds } from './use-normalized-projects-to-ppt';
import { getTotalCapacity } from '../components/generate-teaser/helpers';

export function useOpportunityToPpt(opportunity: any) {

    const projectIds = useOpportunityProjectIds(opportunity);
    const { projects, isFetching } = useNormalizedProjectsByIds(projectIds);

    const pptData: PPTOpportunityData = useMemo(
        () => {

            const hasSolar = opportunity.technologies.types.some((tech: any) => tech === 'solar');
            return {
                id: opportunity.id,
                name: opportunity.name,
                aboutSeller: opportunity.aboutYou,
                executiveSummary: opportunity.comments,
                projects,
                technologies: {
                    capacity: getTotalCapacity(opportunity.technologies.capacity, hasSolar),
                    icons: opportunity.technologies.icons,
                    types: opportunity.technologies.types,
                },
            }
        },
        [opportunity, projects]
    );

    return { pptData, isLoading: isFetching };
}
